module.exports = __webpack_public_path__ + "img/international.256537bf.svg";